import { InjectionToken } from '@angular/core';
import { Action, ActionReducerMap } from '@ngrx/store';
import { AppFeatureName, appReducer } from './app.reducer';
import { OfflineFeatureName, offlineReducer } from './offline.reducer';
import {
  UserDetailsFeatureName,
  userDetailsReducer,
} from './user-details.reducer';

export {
  appReducer,
  AppFeatureName,
  initialState as appInitialState,
  AppState,
} from './app.reducer';
export {
  userDetailsReducer,
  UserDetailsFeatureName,
  initialState as userDetailsInitialState,
  UserDetailsState,
} from './user-details.reducer';
export {
  offlineReducer,
  OfflineFeatureName,
  initialState as offlineInitialState,
  OfflineState,
} from './offline.reducer';
export { metaReducers } from './meta.reducer';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface State {}

/**
 * Our state is composed of a map of action reducer functions.
 * These reducer functions are called with each dispatched action
 * and the current or initial state and return a new immutable state.
 */
export const ROOT_REDUCERS = new InjectionToken<
  ActionReducerMap<State, Action>
>('Root reducers token', {
  factory: () => ({
    [AppFeatureName]: appReducer,
    [UserDetailsFeatureName]: userDetailsReducer,
    [OfflineFeatureName]: offlineReducer,
  }),
});
